<template>
	<div class="pro" v-if="showPage">
		<!-- tab切换 -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="全部项目" name="1"></el-tab-pane>
			<el-tab-pane label="待兑现" name="2"></el-tab-pane>
			<el-tab-pane label="已兑现" name="3"></el-tab-pane>
			<el-tab-pane label="审核中" name="4"></el-tab-pane>
			<el-tab-pane label="审核已通过" name="5"></el-tab-pane>
			<el-tab-pane label="审核不通过" name="6"></el-tab-pane>
			<el-tab-pane label="公示中" name="7"></el-tab-pane>
		</el-tabs>
		<!-- 列表 -->
		<el-table :data="tableData" style="width: 100%;">
			<template slot="empty">
				<div class="lack m_t30">
					<img style="height: 100px;" src="@images/center/recom.png" alt="" />
					<div style="text-align: center; margin-top: 20px;">无匹配政策</div>
				</div>
			</template>
			<el-table-column type="index" label="序号" width="80" min-width="10" />
			<el-table-column
				prop="title"
				label="项目信息"
				min-width="150"
				show-overflow-tooltip
			></el-table-column>
			<el-table-column
				prop="person"
				label="申报人"
				min-width="125"
				show-overflow-tooltip
			>
			</el-table-column>
			<el-table-column
				prop="price"
				label="金额"
				width="120"
				min-width="10"
				show-overflow-tooltip
			></el-table-column>
			<el-table-column
				prop="status"
				label="项目状态"
				min-width="10"
				width="120"
				show-overflow-tooltip
			></el-table-column>
			<el-table-column label="操作" width="100" min-width="10">
				<template slot-scope="scope">
					<div class="operation">
						<div class="edit btn" @click="handleEdit(scope.row)">
							<img src="@/assets/images/icon/edit@2x.png" alt="" />
						</div>
						<div class="delete btn" @click="handleDelete(scope.row)">
							<img src="@/assets/images/icon/delete@2x.png" alt="" />
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<div class="pagination">
			<Pagination
				:total="total"
				:pages="pages"
				:currentPageSize="currentSize"
				:currentPage="currentPage"
				@currentChange="handleCurrentChange"
			/>
		</div>
		<div class="dialog">
			<el-dialog
				title
				v-if="isDialogP"
				:visible.sync="isDialogP"
				width="66%"
				:before-close="handleCloseP"
				class="applyDialog"
			>
				<PersonDialog :isMaterial="material.length > 0">
					<template v-slot:title>
						{{ title }}
					</template>
					<template v-slot:inform>
						<InputForm
							@submit="save()"
							class="form"
							ref="applyPerson"
							:formData="formDataP"
							:labelWidth="labelWidth"
							:setting="settingP"
						/>
					</template>
					<template v-slot:appliUp>
						<div class="apply-up">
							<el-form class="upload_form">
								<el-form-item
									class="flex flex-justify"
									v-for="(item, index) in material"
									:key="index"
								>
									<div class="flex flex-justify">
										<div class="">
											<div
												class="dialog_left flex flex-start item-center flex-nowrap"
											>
												<div class="require nowrap" v-if="item.require || true">
													[必须]
												</div>
												<div class="label nowrap">{{ item.materialName }}</div>
											</div>
										</div>
										<div class="up_right m_l20 flex flex-start">
											<!-- v-if="!item.fileUrl" -->
											<el-upload
												class="upload btn"
												:action="action"
												:ref="'upload' + index"
												:http-request="
													file => {
														httpRequest(file, item.id);
													}
												"
												:on-remove="
													(file, fileList) =>
														handleRemove(file, fileList, item.id)
												"
												:before-remove="beforeRemove"
												:file-list="fileList[item.id]"
												:auto-upload="true"
												:disabled="disabled"
												:limit="1"
											>
												<!-- multiple
                        :limit="1" -->
												<el-button
													size="small"
													type="primary"
													:disabled="disabled"
													>上传</el-button
												>
											</el-upload>
											<el-button
												v-show="fileList[item.id]"
												type="primary"
												class="btn m_l20 "
												@click="downloadUpFile(fileList[item.id])"
												>下载</el-button
											>
										</div>
									</div>
								</el-form-item>
							</el-form>
						</div>
					</template>
					<template v-slot:btn>
						<div v-if="currentStater <= 2">
							<el-button
								:disabled="disabled"
								size="small"
								type="primary"
								@click="save()"
								>保存</el-button
							>
							<el-button
								:disabled="disabled"
								size="small"
								type="primary"
								@click="submit()"
								>提交</el-button
							>
						</div>
					</template>
				</PersonDialog>
			</el-dialog>
			<el-dialog
				title
				v-if="isDialogU"
				:visible.sync="isDialogU"
				width="66%"
				:before-close="handleCloseU"
				class="applyDialog"
			>
				<UnitDialog :isMaterial="material.length > 0">
					<template v-slot:title>{{ title }}</template>
					<template v-slot:inform>
						<InputForm
							@submit="save()"
							class="form"
							ref="applyCompany"
							:formName="formNameU"
							:labelWidth="labelWidth"
							:formData="formDataU"
							:setting="settingU"
						/>
					</template>
					<template v-slot:appliUp>
						<div class="apply-up">
							<el-form class="upload_form">
								<el-form-item
									class="flex flex-justify"
									v-for="(item, index) in material"
									:key="index"
								>
									<div class="flex flex-justify">
										<div class="">
											<div
												class="dialog_left flex flex-start item-center flex-nowrap"
											>
												<div class="require nowrap" v-if="item.require || true">
													[必须]
												</div>
												<div class="label nowrap">{{ item.materialName }}</div>
											</div>
										</div>
										<div class="up_right m_l20 flex flex-start">
											<!-- v-if="!item.fileUrl" -->
											<el-upload
												class="upload btn"
												:action="action"
												:ref="'upload' + index"
												:http-request="
													file => {
														httpRequest(file, item.id);
													}
												"
												:on-remove="
													(file, fileList) =>
														handleRemove(file, fileList, item.id)
												"
												:before-remove="beforeRemove"
												:file-list="fileList[item.id]"
												:disabled="disabled"
												:auto-upload="true"
												:limit="1"
											>
												<!-- multiple
                        :limit="1" -->
												<el-button
													size="small"
													type="primary"
													:disabled="disabled"
													>上传</el-button
												>
											</el-upload>
											<el-button
												v-if="fileList[item.id]"
												type="primary"
												class="btn m_l20 "
												@click="downloadUpFile(fileList[item.id])"
												>下载</el-button
											>
										</div>
									</div>
								</el-form-item>
							</el-form>
						</div>
					</template>
					<template v-slot:btn>
						<div v-if="currentStater <= 2">
							<el-button
								:disabled="disabled"
								size="small"
								type="primary"
								@click="save()"
								>保存</el-button
							>
							<el-button
								:disabled="disabled"
								size="small"
								type="primary"
								@click="submit()"
								>提交</el-button
							>
						</div>
					</template>
				</UnitDialog>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UnitDialog from "@/components/semantics/ApplyUnitDialog.vue";
import PersonDialog from "@/components/semantics/ApplyPersonDialog.vue";
import InputForm from "@/components/base/form/InputForm.vue";
import config, { FormConfig, FormValid } from "@/config";
import Pagination from "@components/base/pagination/CenterPagination.vue";
const allData = [
	{
		id: 1,
		depart: "工业和信息化局",
		type: "资金补助",
		title: "2021年度中小企业成长支持资金-贷款贴息",
		deadline: "2021/12/30",
		status: "待兑现",
		person: "光速迭代科技（北京）有限公司",
		price: "10万"
	},
	// {
	// 	id: 2,
	// 	depart: "工业和信息化局",
	// 	type: "资金补助",
	// 	title: "2021年度中小企业成长支持资金-直接融资",
	// 	deadline: "2021/12/30",
	// 	status: "待兑现",
	// 	person: "光速迭代科技（北京）有限公司",
	// 	price: "20万"
	// },
	{
		id: 3,
		depart: "财政部",
		type: "资金补助",
		title: "支持中小微企业",
		deadline: "2021/12/30",
		status: "已兑现",
		person: "光速迭代科技（北京）有限公司",
		price: "17万"
	},
	{
		id: 4,
		depart: "工业和信息化局",
		type: "资质认定",
		title: "第三批工信部专精特新“小巨人”奖励",
		deadline: "2021/12/30",
		status: "审核不通过",
		person: "光速迭代科技（北京）有限公司",
		price: "47万"
	}
];
export default {
	name: "Pro",
	components: {
		PersonDialog,
		UnitDialog,
		InputForm,
		Pagination
	},
	data() {
		return {
			action: `${config.basicUrl}/page/itemDeclareForm/uploadingFile`,
			formNameP: "formP",
			formNameU: "formU",
			staterFlag: 1,
			unit_roles: ["unit", "declare"],
			isDialogU: false,
			isDialogP: false,
			activeName: "1",
			declareItemDirectionId: "",
			declareItemId: "",
			fileList: {},
			materialIdList: [],
			currentList: [],
			tableData: [],
			currentPage: 1,
			currentSize: 10,
			material: [],
			total: 0,
			pages: 0,
			title: "",
			disabled: false,
			currentStart: "", // 状态 -1 审核不通过 1待提交 2 已提交  3 审核中 4 审核已通过 5 公示中
			currentStater: "", // 当前弹框状态 -1 审核不通过 1待提交 2 已提交  3 审核中 4 审核已通过 5 公示中
			labelWidth: "160px",
			formDataP: {
				userName: "",
				papersNumber: "",
				contactInform: "",
				address: ""
			},
			settingP: [
				{
					label: "姓名",
					ref: "userName",
					disabled: true,
					type: "input",
					span: 12
				},
				{
					label: "身份证号",
					disabled: true,
					ref: "papersNumber",
					type: "input",
					span: 12
				},
				{
					label: "联系方式",
					ref: "contactInform",
					type: "input",
					disabled: this.disabled,
					span: 12
				},
				{
					label: "联系地址",
					ref: "address",
					disabled: this.disabled,
					type: "input",
					span: 24
				}
			],
			formDataU: {
				unitName: "",
				unitSoleNumber: "",
				unitType: "",
				industry: "",
				address: ""
			},
			settingU: [
				{
					label: "企业名称",
					ref: "unitName",
					disabled: true,
					type: "input",
					style: "double"
				},
				{
					label: "统一社会信用代码",
					ref: "unitSoleNumber",
					disabled: true,
					type: "input",
					style: "double"
				},
				{
					label: "企业类型",
					ref: "unitType",
					span: 12,
					disabled: true,
					type: "cascader",
					options: FormConfig.unit_type
				},
				{
					label: "所属行业",
					type: "cascader",
					ref: "industry",
					disabled: true,
					span: 12,
					options: FormConfig.industry
				},
				{
					label: "企业地址",
					ref: "address",
					type: "input",
					disabled: true,
					span: 24
				}
			],
			showPage: false
		};
	},
	created() {
		if(this.company == '光速迭代科技（北京）有限公司'){
			this.showPage = true
		}else{
			this.showPage = false
		}
		// 判断是否是首页入口跳转至当前页
		if (this.$route.query) {
			let page = this.$route.query.page;
			switch (page) {
				case "0": // 待提交
					this.currentStart = 1;
					this.activeName = "2";
					break;
				case "1": // 待审核
					this.currentStart = 2;
					this.activeName = "3";
					break;
				case "2": // 审核中
					this.currentStart = 3;
					this.activeName = "4";
					break;
				case "3": // 已通过
					this.currentStart = 4;
					this.activeName = "5";
					break;
				case "4": // 未通过
					this.currentStart = -1;
					this.activeName = "6";
					break;
				default:
					this.currentStart = "";
					this.activeName = "1";
					break;
			}
		}
		this.getListData();

		
	},
	computed: mapGetters({
		role: "role",
		id: "id",
		company: 'company'
	}),
	methods: {
		...mapActions({
			getAppliedList: "policy/getAppliedList", // 获取列表数据
			delAppliedList: "policy/delAppliedList", // 删除行
			getApply: "policy/getApplyData",
			getAuthern: "account/getAuthernData",
			getBasic: "account/getBasic",
			getApplyDetail: "policy/getApplyDetail",
			applyProject: "policy/applyProject",
			upload: "upload",
			getDecrypt: "getDecrypt"
		}),
		downloadUpFile(item) {
			const { url } = item[0];
			if (!item) {
				return this.$message.warning("不存在该文件");
			}
			const baseURL =
				process.env.NODE_ENV === "development"
					? config.basicUrl
					: `${location.origin}/`;
			let fullURL = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
				url
			)}`;
			window.open(fullURL);
		},
		async save() {
			if (this.unit_roles.includes(this.role)) {
				this.submitUnit(1);
			} else {
				this.submitPerson(1);
			}
		},
		httpRequest(file, id) {
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)"
			});
			setTimeout(() => {
				loading && loading.close();
			}, 30000);

			return new Promise((resolve, reject) => {
				const options = new FormData();
				options.append("file", file.file);
				this.upload(options).then(({ code, data, msg }) => {
					if (code === 0) {
						// 当当前的上传文件列表有值时，且该值和当前上传的文件所在位置一致

						this.fileList[id] = [
							{
								url: data,
								id
							}
						];
						loading && loading.close();
						resolve(data);
						return data;
					}
					reject(msg);
				});
			});
		},
		async submit() {
			for (let index = 0; index < this.currentList.length; index++) {
				const refName = "upload" + index;
				// await (this.$refs[refName] as any)[0].submit();
			}
			if (this.unit_roles.includes(this.role)) {
				this.submitUnit(2);
			} else {
				this.submitPerson(2);
			}
		},
		submitUnit(stater) {
			const {
				unitName: unitName,
				unitSoleNumber: creditCode,
				unitType,
				industry,
				address: unitAddress
			} = this.formDataU;

			// const tempMaterail = this.material.map((item: any) => {
			//   const {id:declareItemMaterialId,materialName,templateUrl,uploadRequest,stater} = item;
			//   return item;
			// })
			const material = [];
			for (const i in this.fileList) {
				if (this.fileList[i].length) {
					const { url: fileUrl } = this.fileList[i][0];
					material.push({
						declareItemMaterialId: i,
						fileUrl,
						stater: 1
					});
				}
			}
			if (stater === 2 && this.material.length !== material.length) {
				return this.$message.warning("请完整上传材料");
			}
			const options = {
				alreadySubmittedMaterials: material,
				// contactDetails:contactDetails[0],
				industry: industry[0] || null,
				unitAddress: unitAddress || null,
				stater,
				declareItemId: this.declareItemId,
				declareItemDirectionId: this.declareItemDirectionId,
				userId: this.id,
				unitType: unitType[0] || null
			};

			this.applyProject(options).then(({ code, data, msg }) => {
				if (code === 0) {
					if (stater === 2) {
						this.isDialogU = false;
						return this.$message.success("提交成功!");
					}
					this.isDialogU = false;
					return this.$message.success("保存成功!");
				}
			});
		},
		submitPerson(stater) {
			const {
				userName: unitName,
				papersNumber: creditCode,
				contactInform: contactDetails,
				address: contactAddress
			} = this.formDataP;
			// const tempMaterail = this.material.map((item: any) => {
			//   const {id:declareItemMaterialId,materialName,templateUrl,uploadRequest,stater} = item;
			//   return {}
			// })
			const material = [];
			for (const i in this.fileList) {
				if (this.fileList[i].length) {
					const { url: fileUrl } = this.fileList[i][0];
					material.push({
						declareItemMaterialId: i,
						fileUrl,
						stater: 1
					});
				}
			}
			material.map(item => {});
			if (stater === 2 && this.material.length !== material.length) {
				return this.$message.warning("请完整上传材料");
			}
			const options = {
				alreadySubmittedMaterials: material,
				contactDetails,
				contactAddress,
				stater,
				declareItemId: this.declareItemId,
				declareItemDirectionId: this.declareItemDirectionId,
				unitType: this.role,
				userId: this.id
			};

			this.applyProject(options).then(({ code, data, msg }) => {
				if (code === 0) {
					if (stater === 2) {
						this.isDialogP = false;
						return this.$message.success("提交成功!");
					}
					this.isDialogP = false;
					return this.$message.success("保存成功!");
				}
			});
		},
		beforeRemove(file) {},
		handleRemove(file, fileList, id) {
			this.fileList[id] = fileList;
			return fileList;
		},
		// 获取列表数据
		getListData() {
			let reqData = {
				current: this.currentPage, // 当前页
				size: this.currentSize, // 每页个数
				start: this.currentStart // 状态
			};
			const types = [null, "待兑现", "已兑现"];
			if (!reqData.start || reqData.start == "0") {
				return (this.tableData = allData);
			}
			let type = types[reqData.start];
			if (!type && reqData.start === -1) {
				type = "审核不通过";
			}
			this.tableData = allData.filter(item => item.status == type);
			// this.getAppliedList(reqData).then(({ code, data, msg }) => {
			// 	if (code === 0) {
			// 		if (!data) {
			// 			this.pages = 0;
			// 			this.tableData = [];
			// 			return (this.total = 0);
			// 		}
			// 		const { total, records, pages } = data;
			// 		this.pages = pages;
			// 		this.total = total;
			// 		this.tableData = records
			// 			.filter(item => {
			// 				return item.declareItemDirection;
			// 			})
			// 			.map(item => {
			// 				// 项目信息
			// 				item.message = `${item.declareItem && item.declareItem.title}(${
			// 					item.declareItemDirection.dispatchDirection
			// 				})`;
			// 				// 申报人
			// 				item.person =
			// 					item.user && item.user.accountNumber
			// 						? item.user.accountNumber || null
			// 						: item.unitName || null;
			// 				// 金额
			// 				item.je = `${item.declareItemDirection.supportAmount}元`;
			// 				// 状态
			// 				switch (item.stater) {
			// 					case 1:
			// 						item.stater = "待提交";
			// 						break;
			// 					case 2:
			// 						item.stater = "已提交";
			// 						break;
			// 					case 3:
			// 						item.stater = "审核中";
			// 						break;
			// 					case 4:
			// 						item.stater = "审核已通过";
			// 						break;
			// 					case 5:
			// 						item.stater = "公示中";
			// 						break;
			// 					case -1:
			// 						item.stater = "审核不通过";
			// 						break;
			// 				}
			// 				return item;
			// 			});
			// 	}
			// });
		},
		// tab切换方法
		handleClick(tab, event) {
			switch (this.activeName) {
				case "1": // 全部项目
					this.currentStart = "";
					break;
				case "2": // 待提交
					this.currentStart = 1;
					break;
				case "3": // 已提交
					this.currentStart = 2;
					break;
				case "4": // 审核中
					this.currentStart = 3;
					break;
				case "5": // 审核已通过
					this.currentStart = 4;
					break;
				case "6": // 审核不通过
					this.currentStart = -1;
					break;
				case "7": // 公示中
					this.currentStart = 5;
					break;
				default:
					this.currentStart = "";
					break;
			}
			this.getListData();
		},
		// 分页
		handleSizeChange(val) {},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getListData();
		},
		// 编辑当前行数据
		async handleEdit(data) {
			// 获取数据
			const {
				alreadySubmittedMaterials: material,
				message,
				stater: currentStater
			} = data;
			switch (currentStater) {
				case "待提交":
					this.currentStater = 1;
					break;
				case "已提交":
					this.currentStater = 2;
					break;
				default:
					break;
			}
			this.disabled = false;
			this.title = message;
			if (this.unit_roles.includes(this.role)) {
				const {
					unitName,
					unitSoleNumber: creditCode,
					unitType,
					industry,
					unitAddress,
					declareItemDirection,
					alreadySubmittedMaterials
				} = data;

				const { declareItemId, id } = declareItemDirection;
				this.declareItemDirectionId = id;
				this.declareItemId = declareItemId;
				this.currentList = alreadySubmittedMaterials;
				// 基础信息数据
				this.formDataU.unitName = unitName;
				this.formDataU.unitSoleNumber = creditCode;
				this.formDataU.unitType = [unitType];
				this.formDataU.industry = [industry];
				this.formDataU.address = unitAddress;
			} else {
				const {
					alreadySubmittedMaterials,
					userName,
					contactDetails,
					contactAddress,
					papersNumber,
					declareItemDirection
				} = data;
				const { declareItemId, id } = declareItemDirection;
				this.declareItemDirectionId = id;
				this.declareItemId = declareItemId;
				this.currentList = alreadySubmittedMaterials;
				this.formDataP.userName = userName;
				this.formDataP.contactInform = contactDetails;
				this.formDataP.address = contactAddress;
				this.formDataP.papersNumber = papersNumber;
			}
			// 获取完整的材料

			const res = await this.getApplyDetail({
				declareItemId: this.declareItemId
			});
			const { code, data: resData, msg } = res;
			const { declareItemDirections, stater: backStater } = resData;
			if (backStater != 3 || this.currentStater === 2) {
				this.disabled = true;
			} else {
				this.disabled = false;
			}
			const currentDirection = declareItemDirections.filter(
				item => item.id === this.declareItemDirectionId
			);
			if (currentDirection.length > 0) {
				const { declareItemMaterials } = currentDirection[0];
				const materialIdList = [];
				this.material = declareItemMaterials.map(item => {
					materialIdList.push(String(item.id));
					item.r_other = [];
					if (item.isSignature === 1) {
						item.r_other.push("必须签字");
					}
					if (item.isStamp === 1) {
						item.r_other.push("必须盖章");
					}
					return item;
				});
				this.materialIdList = materialIdList;
			}
			this.currentList = material.filter(item => {
				return this.materialIdList.includes(String(item.declareItemMaterialId));
			});
			this.fileList = {};
			for (let currentMaterial of this.currentList) {
				if (
					currentMaterial.fileUrl &&
					this.materialIdList.includes(currentMaterial.declareItemMaterialId)
				) {
					// this.fileList[item.declareItemMaterialId] = {};
					const oritinalName = await this.getDecrypt(currentMaterial.fileUrl);
					const { request } = oritinalName;
					const { response } = request;
					const fileName = response.split("-")[response.split("-").length - 1];
					this.fileList[currentMaterial.declareItemMaterialId] = [
						{ url: currentMaterial.fileUrl, name: fileName }
					];
				}
			}
			// 打开弹框
			this.showDialog();
		},
		showDialog() {
			if (this.unit_roles.includes(this.role)) {
				return this.showUnitDialog();
			}
			return this.showPersonDialog();
		},
		// 打开企业弹框
		showUnitDialog() {
			this.isDialogU = true;
		},
		// 打开个人弹框
		showPersonDialog() {
			this.isDialogP = true;
		},
		// 关闭个人弹框
		handleCloseP() {
			this.isDialogP = false;
			this.getListData();
		},
		// 关闭企业弹框
		handleCloseU() {
			this.isDialogU = false;
			this.getListData();
		},
		// 删除当前行
		handleDelete(data) {
			let reqData = {
				itemDeclareFormId: data.id,
				userId: data.user.id
			};
			this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.delAppliedList(reqData).then(data => {
						if (data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!"
							});
							this.getListData();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		}
	}
};
</script>

<style lang='scss' scoped>
.upload_form {
	/deep/ .el-form-item,
	/deep/ .el-form-item__content {
		width: 100%;
	}
}

.pro {
	.pagination {
		margin-top: 20px;
		display: flex;
		justify-content: center;
		align-items: center;

		.total_page {
			font-size: 14px;
			font-weight: 400;
			color: #606266;
			margin-right: 10px;
		}
	}

	.operation {
		display: flex;
		flex-wrap: nowrap;
		justify-content: flex-start;

		.edit {
			width: 18px;
		}

		.delete {
			margin-left: 14px;
			width: 18px;
		}

		.edit,
		.delete {
			img {
				width: 100%;
			}
		}
	}
}

/deep/ .el-tabs__item {
	padding: 0 50px;
	margin-bottom: 10px;
	font-size: 16px;
	font-weight: bold;
	color: $black;

	&:first-of-type {
		padding-left: 0;
	}
}

/deep/ .is-active {
	color: $black;
	font-size: 20px;
}

/deep/ .el-tabs__active-bar {
	background-color: transparent;
}

.pro {
	/deep/.el-tabs__nav-wrap::after {
		height: 0;
	}
}

.dialog_left {
	width: inherit;
	min-width: 100px;
}
</style>
